import { FormKitNode } from "@formkit/core";

/**
 * Disable load on open for autocomplete inputs.
 */
export default function disableLoadOnOpen(node: FormKitNode): void {
  if (node.props.type === "autocomplete") {
    node.props.alwaysLoadOnOpen = false;
  }
}
